import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './PrivacyPolicy.css';

const PrivacyPolicy: React.FC = () => {
  const { language } = useLanguage();
  const nl = language === 'nl';

  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>{nl ? 'Privacyverklaring' : 'Privacy Policy'}</h1>
        <p className="policy-updated">{nl ? 'Laatst bijgewerkt: februari 2025' : 'Last updated: February 2025'}</p>

        <section>
          <h2>{nl ? '1. Wie we zijn' : '1. Who we are'}</h2>
          <p>
            Meijer &amp; Knijnenberg, Nieuwezijds voorburgwal 334-2, Amsterdam. Contact: info@meijerknijnenberg.com, 020 308 6271.
          </p>
        </section>

        <section>
          <h2>{nl ? '2. Welke gegevens we verwerken' : '2. Data we process'}</h2>
          <ul>
            <li>{nl ? 'Contact- en sollicitatiegegevens (naam, e-mail, telefoon, CV, motivatie).' : 'Contact and application details (name, email, phone, CV, cover note).'}</li>
            <li>{nl ? 'Professionele informatie (ervaring, vaardigheden, voorkeuren, beschikbaarheid, salarisindicatie).' : 'Professional info (experience, skills, preferences, availability, salary indication).'}</li>
            <li>{nl ? 'Website- en formulierdata (technische logs, formulierinhoud).' : 'Website/form data (technical logs, form content).'}</li>
          </ul>
        </section>

        <section>
          <h2>{nl ? '3. Waarom we deze gegevens gebruiken' : '3. Why we use your data'}</h2>
          <ul>
            <li>{nl ? 'Recruitment: matchen van kandidaten met rollen en informeren van klanten.' : 'Recruitment: matching candidates to roles and informing clients.'}</li>
            <li>{nl ? 'Communicatie over vacatures, voorstellen en planningen.' : 'Communications about roles, introductions, and scheduling.'}</li>
            <li>{nl ? 'Wettelijke verplichtingen en beveiliging.' : 'Legal obligations and security.'}</li>
          </ul>
        </section>

        <section>
          <h2>{nl ? '4. Rechtsgrondslagen' : '4. Legal bases'}</h2>
          <ul>
            <li>{nl ? 'Toestemming (bij formulierinzendingen).' : 'Consent (when you submit forms).'}</li>
            <li>{nl ? 'Gerechtvaardigd belang (recruitment- en klantprocessen).' : 'Legitimate interest (recruitment and client processes).'}</li>
            <li>{nl ? 'Wettelijke verplichting waar van toepassing.' : 'Legal obligation where applicable.'}</li>
          </ul>
        </section>

        <section>
          <h2>{nl ? '5. Delen met derden' : '5. Sharing with third parties'}</h2>
          <ul>
            <li>{nl ? 'Recruitment-klanten en opdrachtgevers wanneer relevant voor een match.' : 'Recruitment clients when relevant for a match.'}</li>
            <li>{nl ? 'Verwerkers: hosting, e-mail, analytics (alleen voor noodzakelijke verwerking).' : 'Processors: hosting, email, analytics (only as needed).'}</li>
            <li>{nl ? 'Alleen binnen de EU/EER, tenzij passend beschermingsniveau is geborgd.' : 'EU/EEA only, unless adequate protection is ensured.'}</li>
          </ul>
        </section>

        <section>
          <h2>{nl ? '6. Bewaartermijnen' : '6. Retention'}</h2>
          <p>
            {nl
              ? 'We bewaren gegevens zolang nodig voor recruitment en conform wettelijke termijnen. Je kunt eerder verwijdering vragen.'
              : 'We retain data as needed for recruitment and legal purposes. You may request earlier deletion.'}
          </p>
        </section>

        <section>
          <h2>{nl ? '7. Jouw rechten' : '7. Your rights'}</h2>
          <ul>
            <li>{nl ? 'Inzien, rectificeren, wissen, beperken, bezwaar maken, dataportabiliteit.' : 'Access, rectify, erase, restrict, object, data portability.'}</li>
            <li>{nl ? 'Toestemming intrekken (indien van toepassing).' : 'Withdraw consent (where applicable).'}</li>
            <li>
              {nl
                ? 'Neem contact op via info@meijerknijnenberg.com; je kunt ook een klacht indienen bij de Autoriteit Persoonsgegevens.'
                : 'Contact info@meijerknijnenberg.com; you may also lodge a complaint with the Dutch DPA.'}
            </li>
          </ul>
        </section>

        <section>
          <h2>{nl ? '8. Beveiliging' : '8. Security'}</h2>
          <p>
            {nl
              ? 'We nemen passende technische en organisatorische maatregelen om gegevens te beschermen en toegang te beperken.'
              : 'We apply appropriate technical and organizational measures to protect data and restrict access.'}
          </p>
        </section>

        <section>
          <h2>{nl ? '9. Cookies & analytics' : '9. Cookies & analytics'}</h2>
          <p>
            {nl
              ? 'Zie onze Cookieverklaring voor details. We gebruiken alleen noodzakelijke en analytische tools (zoals Vercel Analytics) met minimale persoonsgegevens.'
              : 'See our Cookie Policy for details. We use only necessary and minimal analytics (e.g., Vercel Analytics) with limited personal data.'}
          </p>
        </section>

        <section>
          <h2>{nl ? '10. Contact' : '10. Contact'}</h2>
          <p>
            {nl
              ? 'Vragen of verzoeken? Stuur een e-mail naar info@meijerknijnenberg.com.'
              : 'Questions or requests? Email us at info@meijerknijnenberg.com.'}
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
